import { Skeleton } from "components/ui/skeleton";

export function TimeLineItemSkeleton() {
  return (
    <div className="mb-3 rounded-2xl overflow-hidden
                    bg-surface dark:bg-dark-800
                    border border-line dark:border-white/[0.10]
                    shadow-sm">
                      
      <Skeleton className="h-[3px] w-full rounded-none" animation="shimmer" />

      {/* Main content row */}
      <div className="flex items-center gap-4 px-5 py-3.5">

        {/* Left: icon block + index number */}
        <div className="flex-shrink-0 flex flex-col items-center gap-1">
          <Skeleton variant="block" className="w-10 h-10 rounded-xl" />
          <Skeleton variant="text"  className="!w-6 !h-3 rounded" />
        </div>

        {/* Center: title row + meta chips */}
        <div className="flex-1 min-w-0">
          {/* Title + status pill */}
          <div className="flex items-center gap-2.5 mb-2">
            <Skeleton variant="text" className="!h-4 !w-44" />
            <Skeleton variant="chip" className="h-5 w-20 rounded-full" />
          </div>

          {/* Meta chips row: Template | pipe | Email | pipe | Credits */}
          <div className="flex items-center gap-3 flex-wrap">
            <Skeleton variant="text" className="!h-3.5 !w-24" />
            <Skeleton variant="block" className="w-px h-3 rounded-none" />
            <Skeleton variant="text" className="!h-3.5 !w-32" />
            <Skeleton variant="block" className="w-px h-3 rounded-none" />
            <Skeleton variant="text" className="!h-3.5 !w-16" />
          </div>
        </div>

        {/* Right: date + time stacked */}
        <div className="flex-shrink-0 flex flex-col items-end gap-1.5 ml-2">
          <Skeleton variant="text" className="!h-3.5 !w-24" />
          <Skeleton variant="text" className="!h-3 !w-14" />
        </div>
      </div>
    </div>
  );
}

/**
 * Skeleton for the generic template/event timeline items
 * (used inside EnhancedTemplateHistory).
 * Mirrors a simpler horizontal event row:
 *   [icon 36×36]  [title ──────────]   [timestamp pill]
 *                 [description line]
 */
export function TemplateTimeLineItemSkeleton() {
  return (
    <div className="mb-3 rounded-2xl overflow-hidden
                    bg-surface dark:bg-dark-800
                    border border-line dark:border-white/[0.10]
                    shadow-sm">
      {/* Top accent bar */}
      <Skeleton className="h-[3px] w-full rounded-none" animation="shimmer" />

      <div className="flex items-start gap-4 px-5 py-4">
        {/* Icon badge */}
        <Skeleton variant="block" className="flex-shrink-0 w-9 h-9 rounded-xl mt-0.5" />

        {/* Content */}
        <div className="flex-1 min-w-0">
          {/* Title + timestamp pill */}
          <div className="flex items-center justify-between gap-3 mb-2">
            <Skeleton variant="text" className="!h-4 !w-48" />
            <Skeleton variant="chip" className="h-5 w-28 rounded-full flex-shrink-0" />
          </div>
          {/* Description lines */}
          <div className="space-y-1.5">
            <Skeleton variant="text" className="!h-3 !w-full" />
            <Skeleton variant="text" className="!h-3 !w-3/5" />
          </div>
        </div>
      </div>
    </div>
  );
}
